import { render, staticRenderFns } from "./links.vue?vue&type=template&id=1636b4e6&scoped=true"
import script from "./links.vue?vue&type=script&lang=js"
export * from "./links.vue?vue&type=script&lang=js"
import style0 from "./links.vue?vue&type=style&index=0&id=1636b4e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1636b4e6",
  null
  
)

export default component.exports